module.exports = __webpack_public_path__ + "img/AWAKEN-Landing_page-profile-nikki.b7d6559.png";